import { LinkingRequest } from "pokal_api"

function mockPatientRequests(): LinkingRequest[] {
    return [
        {
            name: "Max Mustermann",
            patient: "mock_patient_max_mustermann",
            id: "mock_lr_max_mustermann"
        }
    ]
}

export default mockPatientRequests
